import { mockRouteMap } from "@/mock/handlers";

function withDelay(result, timeout = 120) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(result), timeout);
  });
}

export function mockAdapter(config) {
  const method = (config.method || "GET").toUpperCase();
  const url = config.url || "";
  const routeKey = `${method} ${url}`;
  const handler = mockRouteMap[routeKey];
  if (!handler) {
    return withDelay({
      code: 4040,
      msg: `Mock 路由不存在: ${routeKey}`,
      data: null
    });
  }
  try {
    const result = handler(config);
    return withDelay(result);
  } catch (error) {
    return withDelay({
      code: 5000,
      msg: error.message || "Mock 服务异常",
      data: null
    });
  }
}
